import React from "react"
import { HStack } from "@fider/components/layout"
import { Button } from "@fider/components"

interface SocialSignInButtonProps {
  option: {
    displayName: string
    provider?: string
    url?: string
    logoBlobKey?: string
    logoURL?: string
  }
  className?: string
  redirectTo?: string
  onClick?: () => void
  title?: string
}

export const SocialSignInButton = (props: SocialSignInButtonProps) => {
  const redirectTo = props.redirectTo || window.location.href
  const href = props.option.url ? `${props.option.url}?redirect=${encodeURIComponent(redirectTo)}` : ""

  const handleClick = async () => {
    // If there is an onClick then let that run and check it finishes OK before doing the oauth.
    if (props.onClick) {
      props.onClick()
      window.location.href = href
    }
  }

  return (
    <a rel="nofollow" className="c-signin-social-button" href={href} onClick={handleClick}>
      <Button variant="primary" size="default" onClick={handleClick}>
        <HStack spacing={1} className="flex-items-center">
          <span>{props.title}</span>
        </HStack>
      </Button>
    </a>
  )
}
